import React, { useState, useEffect, useMemo, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "reducers/rootReducer";
import { formatForRedis } from "utils/appUtil";
import { Select } from "antd";

const { Option } = Select;

const ResponderInput = (props: any) => {
  const { value, placeholder, onChange, adminRoles } = props;
  const { projects, users_filter } = useSelector(
    (state: RootState) => state.auth
  );
  const defaultPagination = 50;
  const [page, setPage] = useState(0);
  const [searching, setSearching] = useState(false);
  const [pagination, setPagination] = useState(true);
  const [options, setOptions] = useState([]);
  const dispatch = useDispatch();
  let timeout;

  const getUsers = (pageNumber, search = "") => {
    setPage(pageNumber);
    setSearching(true);

    const responderRoles = adminRoles
      .filter((x) => {
        return x.permissions.indexOf("onMove") !== -1;
      })
      .map((y) => {
        return `@roleId === '${y._id}'`;
      });

    const requestData = {
      objectType: "user",
      select: {
        index: {
          searchIndex: `${process.env.REACT_APP_ECO_SYSTEM}:userNameIndex`,
          searchQuery: `@serviceId:{'${formatForRedis(
            projects?.userServiceId
          )}'}`,
          searchOptions: "TIMEOUT 1000",
        },
        load: {
          email: "$..live.alternativeIds.email",
          phone: "$..live.alternativeIds.phone",
          profile: "$..profile",
          roleId: "$..admin.profile.roleId",
        },
      },
      groupBy: {
        properties: ["@email", "@phone", "@profile", "@roleId"],
        reducers: [
          {
            func: "TOLIST",
            arguments: ["@objectId"],
            name: "objectIds",
          },
        ],
      },
      apply: {
        expression: "",
        name: "",
      },
      result: {
        pagination: {
          offset: page * defaultPagination,
          limit: defaultPagination,
        },
      },
      filter: {
        expression: `exists(@roleId) && (${responderRoles.join("||")})`,
      },
      anyStatus: false,
    };

    dispatch({
      type: "GET_MAP_PLACES",
      payload: requestData,
    });
    setSearching(true);
  };

  useEffect(() => {
    if (users_filter) {
      setSearching(false);
      const opts = users_filter
        ?.map((x) => {
          return {
            id: x.id,
            name: x.name,
            obj: x,
          };
        })
        .filter((x) => {
          return !options.find((y) => {
            return x.id === y.id;
          });
        });
      setOptions([...options, ...opts]);
      if (opts.length === 0) {
        setPagination(false);
      }
    }
  }, [users_filter]);

  return (
    <Select
      showSearch
      mode={"multiple"}
      className="w-full"
      value={value?.values}
      placeholder={placeholder}
      disabled={adminRoles === undefined}
      onChange={(values) => {
        const changes = [];
        values.map((value) => {
          const responder = options.find((x) => {
            return x.id === value;
          });
          changes.push({
            id: value,
            ...responder.obj,
          });
        });
        onChange({
          type: "responder",
          responders: changes,
          values
        });
      }}
      loading={searching}
      filterOption={(input, option) =>
        (option!.children as unknown as string)
          .toLowerCase()
          .includes(input.toLowerCase())
      }
      onFocus={() => {
        if ((users_filter?.length ?? 0) === 0) getUsers(0);
      }}
      onSearch={(search) => {
        if (timeout) clearTimeout(timeout);
        timeout = setTimeout(() => {
          if (search && search !== "") {
            getUsers(0, search);
            setPagination(false);
          } else getUsers(0);
        }, 500);
      }}
      onPopupScroll={(e: any) => {
        e.persist();
        let target = e.target;
        if (target.scrollTop + target.offsetHeight === target.scrollHeight) {
          if (pagination) {
            getUsers(page + 1);
          }
        }
      }}
    >
      {options?.map((option, index) => (
        <Option key={index} value={option.id}>
          {option.name}
        </Option>
      ))}
    </Select>
  );
};

export default ResponderInput;
